import { render } from "./SurveyLocaleConfig.vue?vue&type=template&id=a2c65002"
import script from "./SurveyLocaleConfig.vue?vue&type=script&lang=js"
export * from "./SurveyLocaleConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__